import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { sendAlert } from '../../actions/utils';
import { notifyCompanyAnnouncementRequest } from '../../requests/companyAnnouncements';

const AnnouncementNotify = ({ announcement, hideModal }) => {
  const dispatch = useDispatch();
  const [isSubmitting, setSubmitting] = useState(false);

  const handleNotification = () => {
    setSubmitting(true);
    notifyCompanyAnnouncementRequest(announcement.id, {
      dispatch,
      successCallback: () => {
        dispatch(sendAlert({ kind: 'success', message: 'Notificación enviada con éxito.' }));
      },
      failureCallback: () => {
        dispatch(sendAlert({ kind: 'error', message: 'Anuncio no encontrado' }));
      },
      callback: () => {
        hideModal();
        setSubmitting(false);
      }
    });
  };

  return (
    <section className="px-3 mt-n3 pb-3">
      <pre>
        <p className="text-justify">
          ¿Estás seguro que quieres enviar una notificación del anuncio #{announcement.name}?
        </p>
      </pre>
      <div className="d-flex flex-row-reverse mt-4">
        <Button variant="primary" onClick={handleNotification} disabled={isSubmitting}>
          Confirmar
        </Button>
      </div>
    </section>
  );
};

export default AnnouncementNotify;
